<template>
  <div v-if="basketKits?.length > 0" class="basket-kits">
    <DefTitle :result="3">
      <h3>{{ title }}</h3>
    </DefTitle>
    <div class="basket-kits-tab">
      <span
        v-for="({ active, items, name }, i) in tabs"
        :key="i"
        class="basket-kits-tab-item"
        :class="{ 'basket-kits-tab-item_active': active }"
        @click="changeActiveTab(i)"
      >
        {{ name }}
      </span>
    </div>
    <DefSlider :settings="settings" :nav="screenWidth >= 992">
      <div v-for="item in getKits" :key="item?.offer?.id ?? item.id" class="swiper-slide">
        <BasketKitsCard :result="item" @click="handlerOpenModal(item)" />
      </div>
    </DefSlider>
  </div>
</template>

<script lang="ts" setup>
import DefTitle from '@components/Def/DefTitle/DefTitle.vue';
import DefSlider from '@components/Def/DefSlider/DefSlider.vue';
import { reactive, computed } from 'vue';
import useScreenWidth from '@use/useScreenWidth';
import BasketKitsCard from '@components/Basket/BasketKits/BasketKitsCard.vue';
import { useStore } from '@/store';
import useModalAside from '@use/useModalAside/useModalAside';
import BasketKitModal from '@components/Basket/BasketKits/BasketKitModal.vue';
import useBasketState from '@use/useBasketState';

const settings = reactive({
  slidesPerView: 2.3,
  breakpoints: {
    968: {
      slidesPerView: 4,
    },
    768: {
      slidesPerView: 3,
    },
  },
});

const screenWidth = useScreenWidth();
const modalAside = useModalAside();
const basketState = useBasketState();

const {
  state: storeState,
  commit,
  // getters
} = useStore();
const basketKits = computed(() => storeState.basket.data?.kits);

const tabs = computed(() => storeState.basket.data?.kitsTabs);
const title = computed(() => storeState.basket.data.messages.kitsTitle);

const getKits = computed(
  () => tabs.value.find((tab) => tab.active)?.items
  // .filter((item) => !getters['basket/inBasket'](item.offer?.id ?? item.id))
);

const changeActiveTab = (i) => {
  commit('basket/changeActiveKits', i);
};

const handlerOpenModal = async (product) => {
  try {
    commit('global/loaderStart');
    const { data, status } = await axios.get(product.detailPage, { params: { api: 'y' } });

    await basketState.close();

    modalAside.show(
      BasketKitModal,
      {
        result: data,
        kitsTabs: tabs.value,
      },
      {
        width: '996px',
        afterRemove: () => {
          basketState.open();
        },
      }
    );
  } catch (err) {
    console.error(err);
  } finally {
    commit('global/loaderStop');
  }
};
</script>

<style lang="scss" scoped>
.basket-kits {
  :deep(.def-slider__prev) {
    left: 0;
    transform: translate(-50%, -50%);
  }
  :deep(.def-slider__next) {
    right: 0;
    transform: translate(50%, -50%);
  }
}
.basket-kits-tab {
  display: flex;
  align-items: center;
  gap: 32px;
  flex-wrap: wrap;
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 500;
  line-height: 125%;
  text-transform: uppercase;
  color: #3f3f44;
}
.basket-kits-tab-item {
  cursor: pointer;
  &_active {
    color: var(--color-main);
    text-decoration: underline;
  }
}
</style>
